<template>
  <div class="app-container">
    <!-- API搜索和添加部分 -->
    <div class="action-container" style="display: flex; margin-bottom: 20px;">
      <el-button type="primary" @click="showAddDialog">添加API</el-button>
      <div style="margin-left: 20px;">
        <el-select v-model="isUsedFilter" placeholder="使用状态" @change="fetchApis">
          <el-option label="全部" :value="null"></el-option>
          <el-option label="已使用" :value="true"></el-option>
          <el-option label="未使用" :value="false"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 20px;">
        <el-button type="success" @click="fetchApis">刷新</el-button>
      </div>
    </div>

    <!-- API表格展示 -->
    <el-table :data="apis" style="width: 100%">
      <el-table-column property="id" label="ID" width="80"></el-table-column>
      <el-table-column property="mail" label="邮箱" show-overflow-tooltip></el-table-column>
      <el-table-column property="password" label="密码" show-overflow-tooltip></el-table-column>
      <el-table-column property="apikey" label="API Key" show-overflow-tooltip></el-table-column>
      <el-table-column property="points" label="Points" width="100"></el-table-column>
      <el-table-column property="isUsed" label="使用状态" width="100">
        <template v-slot:default="scope">
          <el-tag :type="scope.row.isUsed ? 'danger' : 'success'">
            {{ scope.row.isUsed ? '已使用' : '未使用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column property="createTime" label="创建时间" width="180">
        <template v-slot:default="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template v-slot:default="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: red" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalApis">
    </el-pagination>

    <!-- 添加API对话框 -->
    <el-dialog title="添加API" :visible.sync="addDialogVisible" width="30%">
      <el-form :model="newApi" label-width="100px">
        <el-form-item label="邮箱">
          <el-input v-model="newApi.mail" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="newApi.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="API Key">
          <el-input v-model="newApi.apikey" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Points">
          <el-input v-model.number="newApi.points" type="number"></el-input>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-switch v-model="newApi.isUsed" active-text="已使用" inactive-text="未使用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAdd">确认</el-button>
      </span>
    </el-dialog>

    <!-- 编辑API对话框 -->
    <el-dialog title="编辑API" :visible.sync="editDialogVisible" width="30%">
      <el-form :model="currentApi" label-width="100px">
        <el-form-item label="邮箱">
          <el-input v-model="currentApi.mail" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="currentApi.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="API Key">
          <el-input v-model="currentApi.apikey" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Points">
          <el-input v-model.number="currentApi.points" type="number"></el-input>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-switch v-model="currentApi.isUsed" active-text="已使用" inactive-text="未使用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdate">更新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      apis: [],
      totalApis: 0,
      currentPage: 1,
      pageSize: 10,
      isUsedFilter: null,
      addDialogVisible: false,
      editDialogVisible: false,
      newApi: {
        mail: '',
        password: '',
        apikey: '',
        points: 0,
        isUsed: false
      },
      currentApi: {}
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toLocaleString();
    },

    async fetchApis() {
      try {
        const response = await axios.get('/api/admin/nai-point/page', {
          params: {
            current: this.currentPage,
            size: this.pageSize,
            isUsed: this.isUsedFilter
          },
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200) {
          // 直接使用data数组作为apis数据
          this.apis = response.data.data;
          this.totalApis = response.data.total;
          this.currentPage = response.data.current;
          this.pageSize = response.data.size;
        } else {
          this.$message.error('获取API列表失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('获取API列表出错: ' + error.message);
      }
    },

    showAddDialog() {
      this.newApi = {
        mail: '',
        password: '',
        apikey: '',
        points: 0,
        isUsed: false
      };
      this.addDialogVisible = true;
    },

    async handleAdd() {
      try {
        const response = await axios.post('/api/admin/nai-point', this.newApi, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200) {
          this.$message.success('API添加成功');
          this.addDialogVisible = false;
          this.fetchApis();
        } else {
          this.$message.error('API添加失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('API添加出错: ' + error.message);
      }
    },

    handleEdit(api) {
      this.currentApi = {...api};
      this.editDialogVisible = true;
    },

    async handleUpdate() {
      try {
        const response = await axios.put('/api/admin/nai-point', this.currentApi, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200) {
          this.$message.success('API更新成功');
          this.editDialogVisible = false;
          this.fetchApis();
        } else {
          this.$message.error('API更新失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('API更新出错: ' + error.message);
      }
    },

    async handleDelete(id) {
      this.$confirm('确定要删除这个API吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await axios.delete(`/api/admin/nai-point/${id}`, {
            headers: {
              'token': this.$cookies.get('token')
            }
          });

          if (response.data.code === 200) {
            this.$message.success('API删除成功');
            this.fetchApis();
          } else {
            this.$message.error('API删除失败: ' + response.data.msg);
          }
        } catch (error) {
          this.$message.error('API删除出错: ' + error.message);
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchApis();
    }
  },
  mounted() {
    this.fetchApis();
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
